// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__36J84","disabled":"FileBtn_disabled__l32Ih","warn":"FileBtn_warn__3aHiY","fade":"FileBtn_fade__32Hxf"};